// 由 `make gen-perms` 生成，勿手改。真源：internal/domain/tenant（rolePerms、permission_meta.go）。
export const ROLE_MATRIX = {
  "roles": [
    {
      "code": "tenant_owner",
      "label": "企业主",
      "description": "一切操作，含转让企业主、注销企业、充值购座；每家企业只有一个",
      "rank": 3,
      "scopeable": false,
      "permissions": [
        "employee:read",
        "employee:write",
        "employee:control",
        "lead:read",
        "lead:write",
        "lead:delete",
        "lead:phone:read",
        "campaign:read",
        "campaign:write",
        "call:read",
        "recording:read",
        "report:read",
        "export:write",
        "resource:read",
        "resource:write",
        "tenant:read",
        "tenant:write",
        "certification:write",
        "tenant:transfer",
        "tenant:deactivate",
        "member:read",
        "member:write",
        "finance:read",
        "finance:write",
        "apikey:write",
        "audit:read"
      ]
    },
    {
      "code": "tenant_admin",
      "label": "管理员",
      "description": "全部业务、企业设置与管人（管不了其他管理员），不能充值购座、不能注销",
      "rank": 2,
      "scopeable": false,
      "permissions": [
        "employee:read",
        "employee:write",
        "employee:control",
        "lead:read",
        "lead:write",
        "lead:delete",
        "lead:phone:read",
        "campaign:read",
        "campaign:write",
        "call:read",
        "recording:read",
        "report:read",
        "export:write",
        "resource:read",
        "resource:write",
        "tenant:read",
        "tenant:write",
        "certification:write",
        "member:read",
        "member:write",
        "finance:read",
        "apikey:write",
        "audit:read"
      ]
    },
    {
      "code": "tenant_operator",
      "label": "操作员",
      "description": "线索、任务、员工上下岗与试打、看数据；碰不到钱、成员、密钥、员工配置和删除类",
      "rank": 1,
      "scopeable": true,
      "permissions": [
        "employee:read",
        "employee:control",
        "lead:read",
        "lead:write",
        "campaign:read",
        "campaign:write",
        "call:read",
        "recording:read",
        "report:read",
        "export:write",
        "resource:read",
        "tenant:read",
        "member:read"
      ]
    },
    {
      "code": "tenant_finance",
      "label": "财务",
      "description": "资金、发票、合同、企业认证与操作日志；不碰员工、线索、任务的写操作",
      "rank": 1,
      "scopeable": true,
      "permissions": [
        "employee:read",
        "campaign:read",
        "call:read",
        "report:read",
        "export:write",
        "resource:read",
        "tenant:read",
        "certification:write",
        "member:read",
        "finance:read",
        "finance:write",
        "audit:read"
      ]
    },
    {
      "code": "tenant_member",
      "label": "观察员",
      "description": "只读业务数据，没有任何写权限，看不到钱",
      "rank": 1,
      "scopeable": true,
      "permissions": [
        "employee:read",
        "lead:read",
        "campaign:read",
        "call:read",
        "report:read",
        "resource:read",
        "tenant:read",
        "member:read"
      ]
    }
  ],
  "permissions": [
    {
      "code": "employee:read",
      "label": "查看员工",
      "group": "员工",
      "sensitive": false
    },
    {
      "code": "employee:write",
      "label": "雇佣 / 解雇 / 改配置",
      "group": "员工",
      "sensitive": true
    },
    {
      "code": "employee:control",
      "label": "上岗 / 训练 / 暂停 / 试打",
      "group": "员工",
      "sensitive": false
    },
    {
      "code": "lead:read",
      "label": "查看线索",
      "group": "线索",
      "sensitive": false
    },
    {
      "code": "lead:write",
      "label": "新增 / 导入线索、管理黑名单",
      "group": "线索",
      "sensitive": false
    },
    {
      "code": "lead:delete",
      "label": "删除线索 / 遗忘号码",
      "group": "线索",
      "sensitive": true
    },
    {
      "code": "lead:phone:read",
      "label": "查看完整号码",
      "group": "线索",
      "sensitive": true
    },
    {
      "code": "campaign:read",
      "label": "查看任务",
      "group": "任务",
      "sensitive": false
    },
    {
      "code": "campaign:write",
      "label": "建 / 启 / 停任务",
      "group": "任务",
      "sensitive": false
    },
    {
      "code": "call:read",
      "label": "查看话单与转写",
      "group": "话单",
      "sensitive": false
    },
    {
      "code": "recording:read",
      "label": "听录音",
      "group": "话单",
      "sensitive": true
    },
    {
      "code": "report:read",
      "label": "看板与报表",
      "group": "数据",
      "sensitive": false
    },
    {
      "code": "export:write",
      "label": "发起导出",
      "group": "数据",
      "sensitive": true
    },
    {
      "code": "resource:read",
      "label": "查看线路 / 短信 / 加微",
      "group": "资源",
      "sensitive": false
    },
    {
      "code": "resource:write",
      "label": "申请线路、管理短信与加微",
      "group": "资源",
      "sensitive": false
    },
    {
      "code": "tenant:read",
      "label": "查看企业资料与认证",
      "group": "企业",
      "sensitive": false
    },
    {
      "code": "tenant:write",
      "label": "修改企业资料",
      "group": "企业",
      "sensitive": false
    },
    {
      "code": "certification:write",
      "label": "提交企业认证",
      "group": "企业",
      "sensitive": false
    },
    {
      "code": "tenant:transfer",
      "label": "转让企业主",
      "group": "企业",
      "sensitive": true
    },
    {
      "code": "tenant:deactivate",
      "label": "注销企业",
      "group": "企业",
      "sensitive": true
    },
    {
      "code": "member:read",
      "label": "查看成员",
      "group": "成员",
      "sensitive": false
    },
    {
      "code": "member:write",
      "label": "管理成员",
      "group": "成员",
      "sensitive": true
    },
    {
      "code": "finance:read",
      "label": "查看资金与票据",
      "group": "财务",
      "sensitive": false
    },
    {
      "code": "finance:write",
      "label": "充值 / 购退坐席 / 开票",
      "group": "财务",
      "sensitive": true
    },
    {
      "code": "apikey:write",
      "label": "管理 API 密钥",
      "group": "系统",
      "sensitive": true
    },
    {
      "code": "audit:read",
      "label": "查看操作日志",
      "group": "系统",
      "sensitive": false
    }
  ]
} as const;
